import React, { useEffect, useState } from "react";
import { Modal, Typography } from "antd";
import { CloudOutlined } from "@ant-design/icons";
import { get } from "lodash";
import { cardObj } from "../../constants/andOnDashBoard";

const { Title, Paragraph } = Typography;
const OfflineCard = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const updateOnlineStatus = () => setIsOffline(!get(navigator, "onLine"));
  useEffect(() => {
    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);
    return () => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    };
  }, []);
  
  return (
    <Modal
      open={isOffline}
      closable={false}
      footer={null}
      centered
      maskClosable={false}
      className="modern-offline-modal"
      width={350}
      styles={{
        mask: { backgroundColor: "rgba(0, 0, 0, 0.7)" },
        content: {
          padding: "30px",
          borderRadius: "12px",
          textAlign: "center",
          boxShadow: "0 10px 25px rgba(0, 0, 0, 0.2)",
          background: "linear-gradient(135deg, #2a2a2a, #1a1a1a)",
          color: "#ffffff",
        },
      }}
    >
      <div className="flex flex-col items-center justify-center">
        <CloudOutlined
          style={{ fontSize: "60px", color: "#FF4D4F", marginBottom: "20px" }}
        />
        <Title level={3} style={{ color: "#ffffff", marginBottom: "10px" }}>
          {get(cardObj, "title")}
        </Title>
        <Paragraph style={{ color: "#e0e0e0", marginBottom: "30px" }}>
          {get(cardObj, "desciption")}
        </Paragraph>
      </div>
    </Modal>
  );
};

export default OfflineCard;
